import { render, staticRenderFns } from "./MemberInfoDialog.vue?vue&type=template&id=4a63ae1e&scoped=true"
import script from "./MemberInfoDialog.vue?vue&type=script&lang=js"
export * from "./MemberInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./MemberInfoDialog.vue?vue&type=style&index=0&id=4a63ae1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a63ae1e",
  null
  
)

export default component.exports